<template>
  <div class="settings role-new">
    <VPBreadcrumbs :elements="[{ text: 'Roles', to: parentRoute }, { text: 'New Role' }]" />

    <Form
      :form-id="formId"
      :initial-values="TeamRoleDetails.getNew()"
    >
      <div class="form-content">
        <HiddenInput input-id="id" />
        <div class="column-content">
          <FieldsFor name="user">
            <VPInput
              input-id="name"
              placeholder="Add Role name"
            />
          </FieldsFor>
        </div>
      </div>
      <FormActionButtons
        :show-cancel="true"
        :show-save="isFormDirty()"
        :save-label="$gettext('Next')"
        @cancel="onCancel"
        @save="handleSave"
      />
    </Form>
  </div>
</template>

<script setup lang="ts">
import { useTeamRolesStore } from '@/stores/team-roles';
import { Form, useFormsStoreComposable } from 'vuniform';
import { useRootStore } from '@/stores/root';
import { useToast } from 'vue-toastification';
import { useRouter } from 'vue-router';
import VPInput from '@/components/form/VPInput.vue';
import type { TeamRoleInput } from '../../generated/graphql';
import * as TeamRoleDetails from '@/types/TeamRoleDetails';
import VPBreadcrumbs from '@/components/VPBreadcrumbs.vue';
import FormActionButtons from '@/components/form/FormActionButtons.vue';

const teamRolesStore = useTeamRolesStore();
const toast = useToast();
const router = useRouter();
const rootStore = useRootStore();
const parentRoute = { name: 'RoleIndex' };

const { formId, formsStore, formGetValues, isFormDirty } = useFormsStoreComposable('new-roles-form');

const handleSave = async () => {
  const values = formGetValues<TeamRoleInput>();
  values.accountId = rootStore.currentAccountId;
  values.permissionAttributes = {};
  const { result: newTeamRole, errors } = await teamRolesStore.saveTeamRole(values);

  if (errors) {
    formsStore.SET_ERRORS({ requesterId: formId, errors });
    return;
  }

  if (!newTeamRole) {
    return;
  }
  toast.success('Team role added');
  router.push({ name: 'RoleEdit', params: { roleId: newTeamRole.id.toString() } });
};
const onCancel = () => {
  formsStore.RESET_FIELD_VALUES(formId);
  router.push(parentRoute);
};
</script>
